export const monthNames = [
  "Januari",
  "Februari",
  "Maret",
  "April",
  "Mei",
  "Juni",
  "Juli",
  "Agustus",
  "September",
  "Oktober",
  "November",
  "Desember",
];

export const formatDot = (value) => {
  const num = Math.round(value || 0);
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

export const isPeriodeTigaBelasDuaEnam = (startDate) => {
  if (!startDate) return false;
  const start = new Date(startDate);
  if (isNaN(start)) return false;
  return start.getDate() === 13;
};

const HARI_PERMANENT_PER_BULAN = 30;
const SECURITY_SHIFT_HOURS = 8;

const hitungJumlahHariPeriode = (startDate, endDate) => {
  if (!startDate || !endDate) return 0;
  const s = new Date(`${startDate}T00:00:00Z`);
  const e = new Date(`${endDate}T00:00:00Z`);
  if (isNaN(s) || isNaN(e) || e < s) return 0;
  return Math.round((e - s) / 86400000) + 1;
};

export const buildPayrollRow = (data, startDate, endDate, typeKaryawan) => {
  const filterType = typeKaryawan === "contract" ? "Contract" : "Permanent";
  const isPermanentFilter = typeKaryawan === "permanent";
  const matchFilterProbation = typeKaryawan === "contract";

  const employeeType = data.employeeType;
  const matchFilter = employeeType === filterType;

  const basicSallary = data.basicSallary || 0;
  const basicSallaryProbation = data.basicSallaryProbation || 0;
  const daySallary = basicSallary / 30;
  const daySallaryProbation = basicSallaryProbation
    ? basicSallaryProbation / 30
    : 0;

  const kurangBayarData = data.kurangBayar || 0;
  const lebihBayarData = data.lebihBayar || 0;

  const summary = data.summary || {};
  const summaryProbation = data.summaryProbation || {};
  const bukanSecurity = data.bagian !== "Security";

  const hariFull = matchFilter ? summary.totalHariFull || 0 : 0;
  const hariHalf = matchFilter ? summary.totalHariHalf || 0 : 0;
  const jamHalf = matchFilter ? summary.totalJamHalf || 0 : 0;
  const hariHalfRequest = matchFilter ? summary.totalHariHalfRequest || 0 : 0;
  const jamHalfRequest = matchFilter ? summary.totalJamHalfRequest || 0 : 0;
  const hariHalfRequestLain = matchFilter
    ? summary.totalHariHalfRequestLain || 0
    : 0;
  const jumlahHariPeriode = hitungJumlahHariPeriode(startDate, endDate);
  const totalHariKerja = matchFilter
    ? employeeType === "Permanent" && jumlahHariPeriode > 0
      ? Math.min(
          Math.max(
            (summary.totalHariKerja || 0) +
              (HARI_PERMANENT_PER_BULAN - jumlahHariPeriode),
            0
          ),
          HARI_PERMANENT_PER_BULAN
        )
      : summary.totalHariKerja || 0
    : 0;
  const totalJamKerja = matchFilter ? summary.totalJamKerja || 0 : 0;

  const hariFullProbation = matchFilterProbation
    ? summaryProbation.totalHariFull || 0
    : 0;
  const hariHalfProbation = matchFilterProbation
    ? summaryProbation.totalHariHalf || 0
    : 0;
  const jamHalfProbation = matchFilterProbation
    ? summaryProbation.totalJamHalf || 0
    : 0;
  const totalHariKerjaProbation = matchFilterProbation
    ? summaryProbation.totalHariKerja || 0
    : 0;
  const totalJamKerjaProbation = matchFilterProbation
    ? summaryProbation.totalJamKerja || 0
    : 0;

  const totalLembur = summary.totalLembur || 0;
  const totalLemburRp = isPermanentFilter ? 0 : totalLembur * 2 * daySallary;
  const totalLemburJam = summary.totalLemburJam || 0;
  const totalLemburJamRp = isPermanentFilter ? 0 : totalLemburJam * daySallary;
  const uangShiftOne = summary.uangShiftOne || 0;
  const uangShiftOneRp =
    isPermanentFilter || !bukanSecurity ? 0 : uangShiftOne * 4000;

  const totalLemburProbation = summaryProbation.totalLembur || 0;
  const totalLemburProbationRp = isPermanentFilter
    ? 0
    : totalLemburProbation * 2 * daySallaryProbation;
  const totalLemburJamProbation = summaryProbation.totalLemburJam || 0;
  const totalLemburJamProbationRp = isPermanentFilter
    ? 0
    : totalLemburJamProbation * daySallaryProbation;
  const uangShiftOneProbation = summaryProbation.uangShiftOne || 0;
  const uangShiftOneProbationRp =
    isPermanentFilter || !bukanSecurity ? 0 : uangShiftOneProbation * 4000;

  const punyaDataProbationDiFilter =
    matchFilterProbation &&
    (hariFullProbation > 0 ||
      hariHalfProbation > 0 ||
      totalLemburProbation > 0 ||
      totalLemburJamProbation > 0 ||
      uangShiftOneProbation > 0);
  const tampilDiFilter = matchFilter || punyaDataProbationDiFilter;
  const kurangBayar = tampilDiFilter ? kurangBayarData : 0;
  const lebihBayar = tampilDiFilter ? lebihBayarData : 0;

  const totalGajiSetengahHari = matchFilter ? (daySallary / 7) * jamHalf : 0;
  const totalGaji = matchFilter
    ? employeeType === "Permanent"
      ? basicSallary
      : daySallary * (totalJamKerja / 7)
    : 0;

  const jamPotonganSetengahHari =
    matchFilter && employeeType === "Permanent"
      ? Math.max(hariHalfRequest * 7 - jamHalfRequest, 0) +
        hariHalfRequestLain * 7
      : 0;
  const jamPotonganSecurity =
    matchFilter && employeeType === "Permanent"
      ? summary.totalJamPotongSecurity || 0
      : 0;
  // Gaji security: dipotong per jam (gaji / 30 / 8)
  const potonganJamSecurity =
    (daySallary / SECURITY_SHIFT_HOURS) * jamPotonganSecurity;
  const potonganSetengahHari = (daySallary / 7) * jamPotonganSetengahHari;

  const gajiSetengahHariDitambahkan =
    employeeType === "Permanent" ? 0 : totalGajiSetengahHari;

  const totalGajiSetengahHariProbation =
    isPermanentFilter || !matchFilterProbation
      ? 0
      : (daySallaryProbation / 7) * jamHalfProbation;

  const totalGajiProbation =
    isPermanentFilter || !matchFilterProbation
      ? 0
      : employeeType === "Permanent"
      ? basicSallaryProbation
      : daySallaryProbation
      ? daySallaryProbation * (totalJamKerjaProbation / 7)
      : 0;

  const periode13to26 = isPeriodeTigaBelasDuaEnam(startDate, endDate);
  const tampilkanTunjangan = matchFilter
    ? employeeType === "Permanent"
      ? true
      : periode13to26
    : false;

  const uangTransport = tampilkanTunjangan ? data.uangTransport || 0 : 0;
  const uangMakan = tampilkanTunjangan ? data.uangMakan || 0 : 0;
  const bpjsTK = tampilkanTunjangan ? data.bpjsTK || 0 : 0;
  const bpjsK = tampilkanTunjangan ? data.bpjsK || 0 : 0;

  const totalIzinDitolak = matchFilter ? summary.totalIzinDitolak || 0 : 0;
  const potonganIzinDitolak =
    employeeType === "Permanent" ? totalIzinDitolak * daySallary : 0;

  // Uang makan security: dipotong per HARI (uang makan / 30).
  // 1) Request SetengahHari: hari dihitung di backend (sisa jam potong > 3 jam)
  // 2) Izin/Sakit ditolak: 1 hari uang makan per hari ditolak
  const isSecurityPermanent =
    matchFilter && employeeType === "Permanent" && !bukanSecurity;
  const uangMakanPerHariSecurity = uangMakan / HARI_PERMANENT_PER_BULAN;

  const hariPotongUangMakanSecurity = isSecurityPermanent
    ? summary.totalHariPotongUangMakanSecurity || 0
    : 0;
  const potonganUangMakanSecurity = Math.min(
    uangMakanPerHariSecurity * hariPotongUangMakanSecurity,
    uangMakan
  );

  const hariPotongUangMakanIzinDitolakSecurity = isSecurityPermanent
    ? totalIzinDitolak
    : 0;
  const potonganUangMakanIzinDitolakSecurity = Math.min(
    uangMakanPerHariSecurity * hariPotongUangMakanIzinDitolakSecurity,
    Math.max(uangMakan - potonganUangMakanSecurity, 0)
  );

  const totalIzinDitolakProbation = matchFilterProbation
    ? summaryProbation.totalIzinDitolak || 0
    : 0;
  const potonganIzinDitolakProbation =
    employeeType === "Permanent"
      ? totalIzinDitolakProbation * daySallaryProbation
      : 0;

  const totalAlpha = matchFilter ? summary.totalAlpha || 0 : 0;
  const potonganAlpha =
    employeeType === "Permanent" && bukanSecurity ? totalAlpha * daySallary : 0;

  const totalAlphaProbation = matchFilterProbation
    ? summaryProbation.totalAlpha || 0
    : 0;
  const potonganAlphaProbation =
    employeeType === "Permanent" && bukanSecurity
      ? totalAlphaProbation * daySallaryProbation
      : 0;

  const totalSebelumPotongan =
    totalGaji +
    gajiSetengahHariDitambahkan +
    totalGajiProbation +
    totalGajiSetengahHariProbation +
    uangTransport +
    uangMakan +
    uangShiftOneRp +
    uangShiftOneProbationRp +
    totalLemburRp +
    totalLemburProbationRp +
    totalLemburJamRp +
    totalLemburJamProbationRp +
    kurangBayar;

  const takeHomePay = Math.round(
    totalSebelumPotongan -
      bpjsTK -
      bpjsK -
      potonganIzinDitolak -
      potonganIzinDitolakProbation -
      potonganAlpha -
      potonganAlphaProbation -
      potonganSetengahHari -
      potonganJamSecurity -
      potonganUangMakanSecurity -
      potonganUangMakanIzinDitolakSecurity -
      lebihBayar
  );

  return {
    userId: data.userId,
    name: data.name,
    bagian: data.bagian,
    employeeType,
    bankAccountNumber: data.bankAccountNumber ?? "",

    detail: Array.isArray(data.detail) ? data.detail : [],

    daySallary,
    daySallaryProbation,
    totalLembur,
    totalLemburJam,
    uangShiftOne,
    totalLemburProbation,
    totalLemburJamProbation,
    uangShiftOneProbation,
    totalIzinDitolak,
    totalIzinDitolakProbation,
    totalAlpha,
    totalAlphaProbation,

    hariFull,
    hariHalf,
    jamHalf,
    totalHariKerja,
    totalJamKerja,
    hariFullProbation,
    hariHalfProbation,
    jamHalfProbation,
    totalHariKerjaProbation,
    totalJamKerjaProbation,

    totalGaji,
    totalGajiSetengahHari,
    uangShiftOneRp,
    totalLemburRp,
    totalLemburJamRp,
    totalGajiProbation,
    totalGajiSetengahHariProbation,
    uangShiftOneProbationRp,
    totalLemburProbationRp,
    totalLemburJamProbationRp,
    uangTransport,
    uangMakan,
    kurangBayar,

    bpjsTK,
    bpjsK,
    potonganIzinDitolak,
    potonganIzinDitolakProbation,
    potonganAlpha,
    potonganAlphaProbation,
    potonganSetengahHari,
    jamPotonganSetengahHari,
    potonganJamSecurity,
    jamPotonganSecurity,
    uangMakanPerHariSecurity,
    hariPotongUangMakanSecurity,
    potonganUangMakanSecurity,
    hariPotongUangMakanIzinDitolakSecurity,
    potonganUangMakanIzinDitolakSecurity,
    lebihBayar,

    totalSebelumPotongan,
    takeHomePay,
  };
};

export const hitungTakeHomePay = (data, startDate, endDate, typeKaryawan) =>
  buildPayrollRow(data, startDate, endDate, typeKaryawan).takeHomePay;
